module.exports = __webpack_public_path__ + "img/diamondjewelry@2x.92d06fa.jpg";